
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 16.2019V18.6058C0 18.6382 0.00132921 18.6702 0.00393797 18.7019C0.00132921 18.7336 0 18.7657 0 18.7981C0 19.4619 0.559644 20 1.25 20H18.75C19.4404 20 20 19.4619 20 18.7981C20 18.7606 19.9982 18.7236 19.9947 18.6871C19.9966 18.6602 19.9976 18.6331 19.9976 18.6058V16.2019C19.9976 15.5381 19.4379 15 18.7476 15C18.0572 15 17.4976 15.5381 17.4976 16.2019V17.5961H2.5V16.2019C2.5 15.5381 1.94036 15 1.25 15C0.559644 15 0 15.5381 0 16.2019Z"}}),_c('path',{attrs:{"d":"M8.80476 10.574C8.80308 10.5489 8.80224 10.5237 8.80224 10.4984V1.16649C8.80224 0.857117 8.92866 0.560416 9.1537 0.341657C9.37874 0.122898 9.68396 0 10.0022 0C10.3205 0 10.6257 0.122898 10.8507 0.341657C11.0758 0.560416 11.2022 0.857117 11.2022 1.16649V10.4984C11.2022 10.5017 11.2022 10.505 11.2021 10.5083L14.0815 8.40082C14.3361 8.21519 14.6561 8.13549 14.9711 8.17924C15.2862 8.22299 15.5705 8.38662 15.7614 8.63411C15.9524 8.88161 16.0344 9.19271 15.9894 9.49897C15.9443 9.80524 15.776 10.0816 15.5214 10.2672L10.7215 13.7667C10.5138 13.9181 10.2612 14 10.0016 14C9.75278 14.0018 9.50957 13.9284 9.30557 13.79L4.50569 10.5005C4.24699 10.3221 4.07147 10.0514 4.0175 9.74756C3.96353 9.44372 4.03551 9.13147 4.21769 8.87908C4.30863 8.75292 4.42438 8.64552 4.55825 8.56308C4.69212 8.48064 4.84146 8.4248 4.99766 8.39877C5.15385 8.37274 5.3138 8.37704 5.46827 8.41143C5.62274 8.44582 5.76868 8.50961 5.89765 8.59912L8.80476 10.574Z"}})])
          )
        }
      }
    